export{KibSectionHeading}from"./kib-section-heading";export*from"./typings";